export { BoundedImage } from './BoundedImage'
